// View As ("au=") lives only in the query string — user_helper.php reads
// $_GET['au'] on every request with no session fallback — so any link rendered
// without it silently ends the impersonation and drops the WD back to their own
// account. Most catalog links never call the server-side addAU() helper, so this
// pass is what actually keeps View As alive while navigating.

function getAsUserId() {
    var $au = $('#au');

    return $au.length ? String($au.val() || '') : '';
}

function isExternal(url) {
    if (!/^(?:[a-z][a-z0-9+.-]*:)?\/\//i.test(url)) {
        return false;
    }

    try {
        return new URL(url, window.location.href).origin !== window.location.origin;
    } catch (e) {
        return true;
    }
}

function skipUrl(url) {
    return (
        !url ||
        /^#/.test(url) ||
        /^(?:tel|mailto|javascript|data|sms):/i.test(url) ||
        isExternal(url)
    );
}

function withAsUser(url, id) {
    // An existing au= was put there deliberately (addAU(), or an explicit
    // override for a different user), so never overwrite it. This also makes
    // the whole pass idempotent when it runs again after an AJAX swap.
    if (/[?&]au=/.test(url)) {
        return url;
    }

    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'au=' + encodeURIComponent(id);
}

/**
 * Append the acting user's `au=` to same-origin links and form actions.
 *
 * Safe to call repeatedly and on any subtree; pass a container element after
 * injecting markup so newly added links get the parameter too.
 *
 * @param {*} [scope]
 */
export function applyViewAsToLinks(scope) {
    var id = getAsUserId();

    if (!id) {
        return;
    }

    var $scope = $(scope || document);

    $scope.find('a').each(function () {
        // Anchors used as buttons have no href at all; attr() returns undefined
        // here, and calling a string method on it used to throw a TypeError that
        // aborted the entire loop, leaving every later link without au=.
        var href = $(this).attr('href');

        if (skipUrl(href)) {
            return;
        }

        $(this).attr('href', withAsUser(href, id));
    });

    $scope.find('form').each(function () {
        var action = $(this).attr('action');

        if (skipUrl(action) || action.length <= 1) {
            return;
        }

        $(this).attr('action', withAsUser(action, id));
    });

    $scope.find('[data-reset-ymm]').each(function () {
        var url = $(this).attr('data-reset-ymm');

        if (!url || url.length <= 1 || url.indexOf('au=') !== -1) {
            return;
        }

        // NOTE: this appends the bare user id as a path segment rather than a
        // query parameter, matching the original inline-script behaviour.
        $(this).attr('data-reset-ymm', url + id);
    });
}